"use client";

import { openVehiclePricing } from "./VehiclePricing";

export default function PricingNavButton() {
    return (
        <button
            type="button"
            onClick={() => openVehiclePricing("finance")}>
            Pricing
        </button>
    );
}
